export default {
// title : 'aa',
// logo : require('@/../extends/logo.png')
};
